module.exports = __webpack_public_path__ + "img/Notepad.e77e4316.svg";